import logo from './logo.svg';
import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import RefundPolicy from './components/RefundPolicy';
import TermsCondition from './components/TermsCondition';
import Contact from './components/Contact';
import PaymentSuccess from './components/PaymentSuccess';
import AppPaymentSuccess from './components/AppPaymentSuccess';
import AppPaymentFail from './components/AppPaymentFail';

function App() {
  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/payment-success" element={<AppPaymentSuccess />} />
          <Route path="/payment-failed" element={<AppPaymentFail />} />
          {/* <Route path="/payment-success" element={<PaymentSuccess />} /> */}
          {/* <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/Terms-and-condition" element={<TermsCondition />} /> */}
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
